import { ReportModalComponent } from './report-modal/report-modal.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NotFoundComponent } from './not-found/not-found.component';
import { NoRecordComponent } from './no-record/no-record.component';
import { OfferItemComponent } from './offer-item/offer-item.component';
import { PickupChoiceItemComponent } from './pickup-choice-item/pickup-choice-item.component';
import { PincodeInputComponent } from './pincode-input/pincode-input.component';
import { WardrobeItemComponent } from './wardrobe-item/wardrobe-item.component';
import { HamburgerMenuComponent } from './hamburger-menu/hamburger-menu.component';
import { SwapItemModalComponent } from './swap-item-modal/swap-item-modal.component';
import { WardrobeItemV1Component } from './wardrobe-item-v1/wardrobe-item-v1.component';
import { EditImageModalComponent } from './edit-image-modal/edit-image-modal.component';
import { SwapRequestItemModalComponent } from './swap-request-item-modal/swap-request-item-modal.component';
import { SwapRequestPaymentModalComponent } from './swap-request-payment-modal/swap-request-payment-modal.component';
import { WardrobeItemV2Component } from './wardrobe-item-v2/wardrobe-item-v2.component';
import { UserFriendsModalComponent } from './user-friends-modal/user-friends-modal.component';
import { CreateBrandModalComponent } from './create-brand-modal/create-brand-modal.component';
import { SubscribeNowModalComponent } from './subscribe-now-modal/subscribe-now-modal.component';
import { CounterOfferModalComponent } from './counter-offer-modal/counter-offer-modal.component';
import { OfferSuccessModalComponent } from './offer-success-modal/offer-success-modal.component';
import { SearchFilterModalComponent } from './search-filter-modal/search-filter-modal.component';
import { CancelSubscriptionComponent } from './cancel-subscription/cancel-subscription.component';
import { ValidationMessagesComponent } from './validation-messages/validation-messages.component';
import { PriceDiscountModalComponent } from './price-discount-modal/price-discount-modal.component';
import { ProductFilterModalComponent } from './product-filter-modal/product-filter-modal.component';
import { CategoryFilterModalComponent } from './category-filter-modal/category-filter-modal.component';
import { ChooseLocationModalComponent } from './choose-location-modal/choose-location-modal.component';
import { SwapSelectItemModalComponent } from './swap-select-item-modal/swap-select-item-modal.component';
import { ProductCategoryModalComponent } from './product-category-modal/product-category-modal.component';
import { DeleteAccountModalComponent } from './delete-account-modal/delete-account-modal.component';
import { OfferNotificationsModalComponent } from './offer-notifications-modal/offer-notifications-modal.component';
import { CancelSwapRequestComponent } from './cancel-swap-request-modal/cancel-swap-request-modal.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';
import { ImageZoomComponent } from './image-zoom/image-zoom.component';
import { BuyerShippingAddressPaymentComponent } from './buyer-shipping-address-payment/buyer-shipping-address-payment.component';
import { DeliveryPickupModalComponent } from './delivery-pickup-modal/delivery-pickup-modal.component';
import { CountryPickerModalComponent } from './country-picker-modal/country-picker-modal.component';
import { SellerShippingAddressComponent } from './seller-shipping-address/seller-shipping-address.component';
import { PayShippingWithMollieComponent } from './pay-shipping-with-mollie/pay-shipping-with-mollie.component';

@NgModule({
  imports: [
    IonicModule,
    FormsModule,
    RouterModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    PipesModule,
    GoogleMapsModule,
    NgxGpAutocompleteModule,
  ],
  declarations: [
    NotFoundComponent,
    NoRecordComponent,
    ValidationMessagesComponent,
    PincodeInputComponent,
    WardrobeItemComponent,
    PriceDiscountModalComponent,
    SwapItemModalComponent,
    SwapRequestItemModalComponent,
    SwapRequestPaymentModalComponent,
    CancelSwapRequestComponent,
    ChooseLocationModalComponent,
    ProductCategoryModalComponent,
    OfferNotificationsModalComponent,
    UserFriendsModalComponent,
    SubscribeNowModalComponent,
    EditImageModalComponent,
    WardrobeItemV2Component,
    ProductFilterModalComponent,
    HamburgerMenuComponent,
    WardrobeItemV1Component,
    SwapSelectItemModalComponent,
    OfferItemComponent,
    PickupChoiceItemComponent,
    CounterOfferModalComponent,
    OfferSuccessModalComponent,
    CreateBrandModalComponent,
    CategoryFilterModalComponent,
    SearchFilterModalComponent,
    CancelSubscriptionComponent,
    DeleteAccountModalComponent,
    ReportModalComponent,
    ImageViewerComponent,
    ImageZoomComponent,
    BuyerShippingAddressPaymentComponent,
    DeliveryPickupModalComponent,
    SellerShippingAddressComponent,
    PayShippingWithMollieComponent,
    CountryPickerModalComponent
  ],
  exports: [
    NotFoundComponent,
    NoRecordComponent,
    ValidationMessagesComponent,
    PincodeInputComponent,
    WardrobeItemComponent,
    PriceDiscountModalComponent,
    SwapItemModalComponent,
    ChooseLocationModalComponent,
    ProductCategoryModalComponent,
    OfferNotificationsModalComponent,
    UserFriendsModalComponent,
    SubscribeNowModalComponent,
    EditImageModalComponent,
    WardrobeItemV2Component,
    ProductFilterModalComponent,
    HamburgerMenuComponent,
    WardrobeItemV1Component,
    SwapSelectItemModalComponent,
    OfferItemComponent,
    PickupChoiceItemComponent,
    CounterOfferModalComponent,
    OfferSuccessModalComponent,
    CreateBrandModalComponent,
    CategoryFilterModalComponent,
    SearchFilterModalComponent,
    DeleteAccountModalComponent,
    ReportModalComponent,
    ImageViewerComponent,
    ImageZoomComponent,
    BuyerShippingAddressPaymentComponent,
    DeliveryPickupModalComponent,
    SellerShippingAddressComponent,
    PayShippingWithMollieComponent,
    CountryPickerModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
